import React, { useState, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import FilterPanel from './components/FilterPanel';
import MotorCard from './components/MotorCard';
import ComparisonPanel from './components/ComparisonPanel';
import Icon from '../../components/AppIcon';

const MotorHonda = () => {
  const [filters, setFilters] = useState({
    search: '',
    category: 'all',
    engineSize: 'all',
    transmission: 'all',
    priceMin: '',
    priceMax: '',
    fuelMin: '',
    sortBy: 'newest'
  });

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [comparisonMotors, setComparisonMotors] = useState([]);

  const motorsData = [
    // =====================
    // MATIC
    // =====================
    {
      id: 1,
      name: "Honda BeAT",
      slug: "beat",
      category: "Matic",
      transmission: "Otomatis",
      image: "/assets/motor//produk/Beat.png",
      imageAlt: "Honda BeAT",
      price: 19174000,
      engineSize: "110cc",
      fuelEfficiency: "60 km/l"
    },
    {
      id: 2,
      name: "Honda Genio",
      slug: "genio",
      category: "Matic",
      transmission: "Otomatis",
      image: "/assets/motor//produk/HondaGenio.webp",
      imageAlt: "Honda Genio",
      price: 20269000,
      engineSize: "110cc",
      fuelEfficiency: "59 km/l"
    },
    {
      id: 3,
      name: "Honda Scoopy",
      slug: "scoopy",
      category: "Matic",
      transmission: "Otomatis",
      image: "/assets/motor//produk/HondaScoppy.webp",
      imageAlt: "Honda Scoopy",
      price: 23584000,
      engineSize: "110cc",
      fuelEfficiency: "59 km/l"
    },
    {
      id: 4,
      name: "Honda Vario 125 eSP",
      slug: "vario-125",
      category: "Matic",
      transmission: "Otomatis",
      image: "/assets/motor//produk/vario125.png",
      imageAlt: "Honda Vario 125",
      price: 25153000,
      engineSize: "125cc",
      fuelEfficiency: "51 km/l"
    },
    {
      id: 5,
      name: "Honda Vario 160",
      slug: "vario-160",
      category: "Matic",
      transmission: "Otomatis",
      image: "/assets/motor//produk/vario160.png",
      imageAlt: "Honda Vario 160",
      price: 28342000,
      engineSize: "160cc",
      fuelEfficiency: "46 km/l"
    },
    {
      id: 6,
      name: "Honda Stylo 160",
      slug: "stylo-160",
      category: "Matic",
      transmission: "Otomatis",
      image: "/assets/motor/produk/stylo160/Stylo-160-ABS-Royal-Matte-Blue.webp",
      imageAlt: "Honda Stylo 160",
      price: 29463000,
      engineSize: "160cc",
      fuelEfficiency: "45 km/l"
    },
    {
      id: 7,
      name: "Honda PCX 160",
      slug: "pcx-160",
      category: "Matic",
      transmission: "Otomatis",
      image: "/assets/motor//produk/pcx.webp",
      imageAlt: "Honda PCX 160",
      price: 34592000,
      engineSize: "160cc",
      fuelEfficiency: "45 km/l"
    },
    {
      id: 8,
      name: "Honda ADV 160",
      slug: "adv-160",
      category: "Matic",
      transmission: "Otomatis",
      image: "/assets/motor//produk/adv.webp",
      imageAlt: "Honda ADV 160",
      price: 37459000,
      engineSize: "160cc",
      fuelEfficiency: "45 km/l"
    },

    // =====================
    // BEBEK
    // =====================
    {
      id: 9,
      name: "Honda Revo",
      slug: "revo",
      category: "Bebek",
      transmission: "Manual",
      image: "/assets/motor//produk/HondaRevo.webp",
      imageAlt: "Honda Revo",
      price: 18179000,
      engineSize: "110cc",
      fuelEfficiency: "60 km/l"
    },
    {
      id: 10,
      name: "Honda Supra X",
      slug: "supra-x",
      category: "Bebek",
      transmission: "Manual",
      image: "/assets/motor//produk/HondaSuprax.webp",
      imageAlt: "Honda Supra X",
      price: 21544000,
      engineSize: "125cc",
      fuelEfficiency: "57 km/l"
    },
    {
      id: 11,
      name: "Honda Supra GTR 150",
      slug: "supra-gtr-150",
      category: "Bebek",
      transmission: "Manual",
      image: "/assets/motor//produk/HondaSupraGtr150.webp",
      imageAlt: "Honda Supra GTR 150",
      price: 26909000,
      engineSize: "150cc",
      fuelEfficiency: "50 km/l"
    },
    // =====================
    // EV
    // =====================
    {
      id: 13,
      name: "Honda EM1 e:",
      slug: "em1-e",
      category: "EV",
      transmission: "Otomatis",
      image: "/assets/motor//produk/HondaEM1e.webp",
      imageAlt: "Honda EM1 e",
      price: 40000000,
      engineSize: "EV",
      fuelEfficiency: "Electric"
    },
    {
      id: 14,
      name: "Honda ICON e:",
      slug: "icon-e",
      category: "EV",
      transmission: "Otomatis",
      image: "/assets/motor//produk/HondaICONe.webp",
      imageAlt: "Honda ICON e",
      price: 28000000,
      engineSize: "EV",
      fuelEfficiency: "Electric"
    },
    {
      id: 15,
      name: "Honda CUV e:",
      slug: "cuv-e",
      category: "EV",
      transmission: "Otomatis",
      image: "/assets/motor//produk/HondaCUVe.webp",
      imageAlt: "Honda CUV e",
      price: 54450000,
      engineSize: "EV",
      fuelEfficiency: "Electric"
    },

    // =====================
    // SPORT
    // =====================
    {
      id: 16,
      name: "Honda CB150 Verza",
      slug: "cb150-verza",
      category: "Sport",
      transmission: "Manual",
      image: "/assets/motor//produk/HondaCB150Verza.webp",
      imageAlt: "Honda CB150 Verza",
      price: 24404000,
      engineSize: "150cc",
      fuelEfficiency: "45 km/l"
    },
    {
      id: 17,
      name: "Honda Sonic 150R",
      slug: "sonic-150r",
      category: "Sport",
      transmission: "Manual",
      image: "/assets/motor//produk/HondaSonic150R.webp",
      imageAlt: "Honda Sonic 150R",
      price: 28984000,
      engineSize: "150cc",
      fuelEfficiency: "43 km/l"
    },
    {
      id: 18,
      name: "Honda CB150R StreetFire",
      slug: "cb150r-streetfire",
      category: "Sport",
      transmission: "Manual",
      image: "/assets/motor//produk/HondaCB150RStreetFire.webp",
      imageAlt: "Honda CB150R StreetFire",
      price: 34874000,
      engineSize: "150cc",
      fuelEfficiency: "42 km/l"
    },
    {
      id: 19,
      name: "Honda CB150X",
      slug: "cb150x",
      category: "Sport",
      transmission: "Manual",
      image: "/assets/motor//produk/HondaCB150X.webp",
      imageAlt: "Honda CB150X",
      price: 35214000,
      engineSize: "150cc",
      fuelEfficiency: "±38 km/l"
    },
    {
      id: 20,
      name: "Honda CBR150R",
      slug: "cbr150r",
      category: "Sport",
      transmission: "Manual",
      image: "/assets/motor//produk/HondaCBR150R.webp",
      imageAlt: "Honda CBR150R",
      price: 39214000,
      engineSize: "150cc",
      fuelEfficiency: "40 km/l"
    },
    {
      id: 21,
      name: "Honda CRF150L",
      slug: "crf150l",
      category: "Sport",
      transmission: "Manual",
      image: "/assets/motor//produk/HondaCRF150L.webp",
      imageAlt: "Honda CRF150L",
      price: 38809000,
      engineSize: "150cc",
      fuelEfficiency: "42 km/l"
    },
    {
      id: 22,
      name: "Honda CBR250RR",
      slug: "cbr250rr",
      category: "Sport",
      transmission: "Manual",
      image: "/assets/motor//produk/HondaCBR250RR.webp",
      imageAlt: "Honda CBR250RR",
      price: 67179000,
      engineSize: "250cc",
      fuelEfficiency: "35 km/l"
    },
    {
      id: 23,
      name: "Honda Monkey",
      slug: "monkey",
      category: "Sport",
      transmission: "Manual",
      image: "/assets/motor//produk/HondaMonkey.webp",
      imageAlt: "Honda Monkey",
      price: 83617000,
      engineSize: "125cc",
      fuelEfficiency: "50 km/l"
    },
    {
      id: 24,
      name: "Honda CRF250 Rally",
      slug: "crf250-rally",
      category: "Sport",
      transmission: "Manual",
      image: "/assets/motor//produk/HondaCRF250Rally.webp",
      imageAlt: "Honda CRF250 Rally",
      price: 93527000,
      engineSize: "250cc",
      fuelEfficiency: "34 km/l"
    }
  ];



  const filteredMotors = useMemo(() => {
    let result = [...motorsData];

    if (filters?.search) {
      result = result?.filter((motor) =>
      motor?.name?.toLowerCase()?.includes(filters?.search?.toLowerCase()) ||
      motor?.category?.toLowerCase()?.includes(filters?.search?.toLowerCase())
      );
    }

    if (filters?.category !== 'all') {
      result = result?.filter((motor) => motor?.category === filters?.category);
    }

    if (filters?.engineSize !== 'all') {
      result = result?.filter((motor) => {
        const size = parseInt(motor?.engineSize);
        switch (filters?.engineSize) {
          case '110-125':
            return size >= 110 && size <= 125;
          case '150-160':
            return size >= 150 && size <= 160;
          case '250-300':
            return size >= 250 && size <= 300;
          case '500+':
            return size >= 500;
          default:
            return true;
        }
      });
    }

    if (filters?.transmission !== 'all') {
      result = result?.filter((motor) => motor?.transmission === filters?.transmission);
    }

    if (filters?.priceMin) {
      result = result?.filter((motor) => motor?.price >= parseInt(filters?.priceMin));
    }

    if (filters?.priceMax) {
      result = result?.filter((motor) => motor?.price <= parseInt(filters?.priceMax));
    }

    if (filters?.fuelMin) {
      result = result?.filter((motor) => {
        const efficiency = parseInt(motor?.fuelEfficiency);
        return efficiency >= parseInt(filters?.fuelMin);
      });
    }

    switch (filters?.sortBy) {
      case 'price-low':
        result?.sort((a, b) => a?.price - b?.price);
        break;
      case 'price-high':
        result?.sort((a, b) => b?.price - a?.price);
        break;
      case 'name':
        result?.sort((a, b) => a?.name?.localeCompare(b?.name));
        break;
      case 'popular':
        result?.sort((a, b) => b?.stock - a?.stock);
        break;
      case 'newest':
      default:
        result?.sort((a, b) => (b?.isNew ? 1 : 0) - (a?.isNew ? 1 : 0));
        break;
    }

    return result;
  }, [filters, motorsData]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleResetFilters = () => {
    setFilters({
      search: '',
      category: 'all',
      engineSize: 'all',
      transmission: 'all',
      priceMin: '',
      priceMax: '',
      fuelMin: '',
      sortBy: 'newest'
    });
  };

  const handleCompare = (motor) => {
    setComparisonMotors((prev) => {
      const exists = prev?.find((m) => m?.id === motor?.id);
      if (exists) {
        return prev?.filter((m) => m?.id !== motor?.id);
      }
      if (prev?.length >= 3) {
        return prev;
      }
      return [...prev, motor];
    });
  };

  const handleRemoveFromComparison = (motorId) => {
    setComparisonMotors((prev) => prev?.filter((m) => m?.id !== motorId));
  };

  const handleClearComparison = () => {
    setComparisonMotors([]);
  };

  const handleConsult = (motor) => {
    const message = `Halo, saya tertarik dengan ${motor?.name}. Bisakah Anda memberikan informasi lebih lanjut?`;
    window.open(`https://wa.me/6288293642972?text=${encodeURIComponent(message)}`, '_blank');
  };


  return (
    <>
      <Helmet>
        <title>Motor Honda - Honda Pamulang Dealer</title>
        <meta name="description" content="Jelajahi koleksi lengkap motor Honda dengan teknologi terkini, desain modern, dan performa terbaik. Temukan motor Honda impian Anda di Honda Pamulang." />
      </Helmet>
      <Header />
      <main className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-6 md:py-8">
          <HeroSection/>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 md:gap-8">
            <aside className="lg:col-span-1">
              <FilterPanel
                filters={filters}
                onFilterChange={handleFilterChange}
                onReset={handleResetFilters}
                isOpen={isFilterOpen}
                onToggle={() => setIsFilterOpen(!isFilterOpen)} />

            </aside>

            <div className="lg:col-span-3">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">
                    Hasil Pencarian
                  </h2>
                  <p className="text-sm text-muted-foreground mt-1">
                    Menampilkan {filteredMotors?.length} dari {motorsData?.length} motor
                  </p>
                </div>

                {comparisonMotors?.length > 0 &&
                <div className="hidden lg:flex items-center space-x-2 bg-primary/10 px-4 py-2 rounded-lg">
                    <Icon name="GitCompare" size={18} color="var(--color-primary)" />
                    <span className="text-sm font-heading font-semibold text-primary">
                      {comparisonMotors?.length} Motor Dipilih
                    </span>
                  </div>
                }
              </div>

              {filteredMotors?.length === 0 ?
              <div className="bg-card rounded-xl p-8 md:p-12 text-center">
                  <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="SearchX" size={40} color="var(--color-muted-foreground)" />
                  </div>
                  <h3 className="text-xl font-heading font-bold text-foreground mb-2">
                    Motor Tidak Ditemukan
                  </h3>
                  <p className="text-muted-foreground mb-6">
                    Tidak ada motor yang sesuai dengan filter Anda. Coba ubah kriteria pencarian.
                  </p>
                  <button
                  onClick={handleResetFilters}
                  className="inline-flex items-center space-x-2 px-6 py-3 bg-primary text-primary-foreground rounded-lg font-heading font-semibold hover:bg-accent transition-colors">

                    <Icon name="RotateCcw" size={18} />
                    <span>Reset Filter</span>
                  </button>
                </div> :

              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6">
                  {filteredMotors?.map((motor) =>
                <MotorCard
                  key={motor?.id}
                  motor={motor}
                  onCompare={handleCompare}
                  onConsult={handleConsult}
                  isComparing={comparisonMotors?.some((m) => m?.id === motor?.id)} />

                )}
                </div>
              }
            </div>
          </div>
        </div>

        {comparisonMotors?.length > 0 &&
        <div className="pb-32 lg:pb-0" />
        }
      </main>
      <ComparisonPanel
        motors={comparisonMotors}
        onRemove={handleRemoveFromComparison}
        onClear={handleClearComparison} />

      <Footer />
    </>);

};

export default MotorHonda;